export const GET_QUANTITATIVE_MOVEMENT = "get_quantitative_movement";
export const GET_QUANTITATIVE_ACTIVITY = 'get_quantitative_activity';